import { combineReducers } from 'redux';
import type { PersistConfig } from 'redux-persist';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import App from './app/reducer';
import Auth from './auth/reducer';
import ImageAsset from './imageAssets/reducer';
import Map from './map/reducer';
import Modals from './modals/reducer';
import Notes from './notes/reducer';
import Properties from './properties/reducer';
import SoilData from './soilData/reducer';
import type { UserState } from './user/models';
import User from './user/reducer';

/* Persist config */

const rootPersistConfig: PersistConfig<RootState> = {
  key: 'root',
  storage,
  whitelist: ['Auth', 'FavoriteFields'],
  blacklist: ['User'],
  version: 2,
};

const userConfig: PersistConfig<UserState> = {
  key: 'User',
  storage,
  blacklist: ['userPreferences'],
  version: 2,
};

const imageAssetConfig = {
  key: 'ImageAsset',
  storage,
  whitelist: [], // 'can receive 'options', 'optionsSide'
};

const mapConfig = {
  key: 'Map',
  storage,
  whitelist: ['labelsVisible', 'showVariabilityHint', 'showVisualLayer', 'mapStyle'],
};

const soilDataConfig = {
  key: 'Soil',
  storage,
  whitelist: ['soilColors'],
};

const rootReducer = combineReducers({
  Properties: Properties,
  App,
  Modals,
  Map: persistReducer(mapConfig, Map),
  Auth,
  User: persistReducer(userConfig, User),
  ImageAsset: persistReducer(imageAssetConfig, ImageAsset),
  Notes,
  SoilData: persistReducer(soilDataConfig, SoilData),
});

export type RootState = ReturnType<typeof rootReducer>;

export default persistReducer<RootState>(rootPersistConfig, rootReducer);
